import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import eventAction from '../../../../redux/actions/eventsBucket';
import OfferBox from '../../../../components/OfferBox';

function SideBarEvent({ slugEvent, event }) {
  const dispatch = useDispatch();
  const eventRedux = useSelector((state) => state.eventsBucket.activeEvent);

  useEffect(() => {
    if (slugEvent && !event) {
      dispatch(eventAction.getEventPublic(slugEvent));
    }
  }, [dispatch, event, slugEvent]);

  let propsEvent = null;
  if (event && event.slug) {
    propsEvent = event;
  } else if (eventRedux && eventRedux.slug) {
    propsEvent = eventRedux;
  }
  return (
    <>
      {propsEvent && (
        <OfferBox
          event={propsEvent}
          hidePlaces
          fullScreen
          noLink
          hidePrices
          showFullTitle
        />
      )}
    </>
  );
}

SideBarEvent.propTypes = {
  slugEvent: PropTypes.string,
  event: PropTypes.shape(),
};

SideBarEvent.defaultProps = {
  slugEvent: null,
  event: {},
};

export default SideBarEvent;
